// extracted by mini-css-extract-plugin
export var infoSection = "_f-1";
export var infoSectionContainer = "_f-0";
export var infoSectionTitleRow = "_f-2";
export var multiLineInfo = "_f-4";
export var strong = "_f-3";